import { Button } from "@/components/ui/button";
import { Link, useLocation } from "react-router-dom";
import logo from "@/assets/logo_perch.svg";
import { Menu, User } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import { useState } from "react";
import { AppLink } from "@/components/AppLink";

const Navigation = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const isPlansPage = location.pathname === "/plans";
  const [open, setOpen] = useState(false);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    if (!isHomePage) {
      return; // Let Link handle navigation to home page
    }
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Plans page uses a specific header background color
  const headerBackground = isPlansPage ? 'rgba(0, 0, 0, 0.95)' : 'rgba(0, 0, 0, 0.95)';

  return (
    <nav 
      className="fixed top-0 w-full z-50 flex justify-center"
      style={{
        background: headerBackground,
      }}
    >
      <div 
        className="flex items-center justify-between px-8 w-full max-w-[1512px]"
        style={{ height: 74 }}
      >
        <Link to="/">
          <img 
            src={logo} 
            alt="Perch Mobile" 
            className="h-[43px] w-auto brightness-0 invert" 
          />
        </Link>
        <div className="hidden md:flex items-center justify-center flex-1 gap-8">
          <Link 
            to="/plans" 
            className="text-white hover:text-mint transition-colors capitalize"
            style={{
              fontFamily: 'Instrument Sans',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '100%',
              letterSpacing: '-0.05em',
            }}
          >
            Plans
          </Link>
          <Link 
            to="/why-perch-mobile" 
            className="text-white hover:text-mint transition-colors capitalize"
            style={{
              fontFamily: 'Instrument Sans',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '100%',
              letterSpacing: '-0.05em',
            }}
          >
            Why Perch
          </Link>
          <Link 
            to="/faq" 
            className="text-white hover:text-mint transition-colors capitalize"
            style={{
              fontFamily: 'Instrument Sans',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '100%',
              letterSpacing: '-0.05em',
            }}
          >
            FAQ
          </Link>
          <Link 
            to="/contact" 
            className="text-white hover:text-mint transition-colors capitalize"
            style={{
              fontFamily: 'Instrument Sans',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '100%',
              letterSpacing: '-0.05em',
            }}
          >
            Contact
          </Link>
          <Link
            to="/perch-internship"
            className="text-white hover:text-mint transition-colors capitalize"
            style={{
              fontFamily: 'Instrument Sans',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '100%',
              letterSpacing: '-0.05em',
            }}
          >
            Jobs
          </Link>
          <Link
            to="/affiliates"
            className="text-white hover:text-mint transition-colors capitalize"
            style={{
              fontFamily: 'Instrument Sans',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '100%',
              letterSpacing: '-0.05em',
            }}
          >
            Affiliates
          </Link>
        </div>
        <div className="hidden md:block">
          <AppLink to="/login">
            <button 
              className="font-sans font-medium text-white text-center capitalize flex items-center justify-center gap-1.5"
              style={{
                width: 93,
                height: 27,
                borderRadius: 5,
                background: '#533DDA',
                fontSize: 12,
                lineHeight: '100%',
                letterSpacing: '-0.05em',
              }}
            >
              <User className="w-2 h-[9px]" strokeWidth={2.5} />
              My Perch
            </button>
          </AppLink>
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" className="md:hidden text-white hover:bg-white/10">
              <Menu className="h-6 w-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[300px] bg-[#242424] border-l-0">
            <div className="flex flex-col gap-6 mt-8">
              <Link 
                to="/plans" 
                className="text-lg text-white hover:text-mint transition-colors"
                onClick={() => setOpen(false)}
              >
                Plans
              </Link>
              <Link 
                to="/why-perch-mobile" 
                className="text-lg text-white hover:text-mint transition-colors"
                onClick={() => setOpen(false)}
              >
                Why Perch
              </Link>
              <Link 
                to="/faq" 
                className="text-lg text-white hover:text-mint transition-colors"
                onClick={() => setOpen(false)}
              >
                FAQ
              </Link>
              <Link 
                to="/contact" 
                className="text-lg text-white hover:text-mint transition-colors"
                onClick={() => setOpen(false)}
              >
                Contact
              </Link>
              <Link
                to="/perch-internship"
                className="text-lg text-white hover:text-mint transition-colors"
                onClick={() => setOpen(false)}
              >
                Jobs
              </Link>
              <Link
                to="/affiliates"
                className="text-lg text-white hover:text-mint transition-colors"
                onClick={() => setOpen(false)}
              >
                Affiliates
              </Link>
              <AppLink to="/login" onClick={() => setOpen(false)}>
                <Button variant="hero" size="sm" className="w-full">
                  My Perch
                </Button>
              </AppLink>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  );
};

export default Navigation;
